import {
  RESET_ATR,
  SAVE_ATR,
  SUBMIT_ATR_COMPLETED,
  SUBMIT_ATR_FAILED,
  SUBMIT_ATR_REQUESTED,
} from '../../actions/atr/types';
import { Action } from '../../utils/redux';

type ReducerActions =
  | Action<typeof RESET_ATR>
  | Action<
      typeof SAVE_ATR,
      {
        answer: {
          id: string;
          text: string;
        };
        id: string;
        question: string;
      }
    >
  | Action<
      typeof SUBMIT_ATR_COMPLETED,
      {
        rating: number;
      }
    >
  | Action<typeof SUBMIT_ATR_FAILED, Error>
  | Action<typeof SUBMIT_ATR_REQUESTED>;

export interface AtrState {
  error: null;
  data: {
    answer: {
      id: string;
      text: string;
    };
    id: string;
    question: string;
  }[];
  loading: boolean;
  score: number;
}

const initialState: AtrState = {
  error: null,
  data: [],
  loading: false,
  score: 0,
};

function reducer(state = initialState, action: ReducerActions) {
  switch (action.type) {
    case RESET_ATR:
      return {
        ...initialState,
      };
    case SAVE_ATR: {
      const { payload } = action;

      return {
        ...state,
        data: [...state.data.filter(({ id }) => id !== payload.id), payload],
      };
    }
    case SUBMIT_ATR_COMPLETED: {
      const { rating } = action.payload;

      return {
        ...state,
        loading: false,
        score: rating,
      };
    }
    case SUBMIT_ATR_FAILED: {
      const error = action.payload;

      return {
        ...state,
        error,
        loading: false,
      };
    }
    case SUBMIT_ATR_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
}

export default reducer;
